'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../index-6ed9f31c.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject, _templateObject2;

function setGlobalLockScrollActive(_ref) {
  var open = _ref.open,
      lockScroll = _ref.lockScroll;

  if (open && lockScroll) {
    return xstyledStyledComponents_es.css(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      body {\n        -webkit-overflow-scrolling: touch;\n        overflow: hidden;\n        touch-action: none;\n        overscroll-behavior: none;\n      }\n    "])));
  }

  return '';
}

var GlobalLockScroll = xstyledStyledComponents_es.createGlobalStyle(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  ", ";\n"])), setGlobalLockScrollActive);
GlobalLockScroll.propTypes = {
  lockScroll: index.PropTypes.bool.isRequired,
  open: index.PropTypes.bool.isRequired
};
GlobalLockScroll.displayName = 'GlobalLockScroll';

function LockScroll(props) {
  return /*#__PURE__*/React__default['default'].createElement(GlobalLockScroll, props);
}

LockScroll.propTypes = {
  lockScroll: index.PropTypes.bool.isRequired,
  open: index.PropTypes.bool.isRequired
};

exports.default = LockScroll;
//# sourceMappingURL=LockScroll.js.map
